// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOilJerryCan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 3.5H8a.5.5 0 0 0-.5.5v1h4V4a.5.5 0 0 0-.5-.5zM8 2h3a2 2 0 0 1 2 2v1.01a3 3 0 0 1 1.35.448l1.078-1.077a2 2 0 0 1 2.828 0l1.488 1.488a2 2 0 0 1 0 2.828l-1.11 1.11A3 3 0 0 1 19 11.243V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8c0-1.306.835-2.417 2-2.83V4a2 2 0 0 1 2-2zM6 19a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-7.757a1 1 0 0 0-.293-.708l-3.243-3.242A1 1 0 0 0 12.758 7H7a1 1 0 0 0-1 1zM16.488 5.442l-1.023 1.023L17.66 8.66l1.023-1.023a.5.5 0 0 0 0-.707l-1.487-1.488a.5.5 0 0 0-.708 0zm-4.315 7.448a19.94 19.94 0 0 0-.58-1.043.099.099 0 0 0-.17 0c-.196.33-.395.684-.58 1.043-.546 1.062-.835 1.92-.835 2.398 0 .518.52 1.2 1.5 1.2.981 0 1.5-.682 1.5-1.2 0-.478-.288-1.336-.835-2.398zm2.335 2.398c0 1.491-1.343 2.7-3 2.7s-3-1.209-3-2.7c0-1.743 1.8-4.566 2.612-5.75a.467.467 0 0 1 .777 0c.81 1.184 2.611 4.007 2.611 5.75z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOilJerryCan;
